import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function DateRangePicker({
  startDate,
  endDate,
  onChange,
  isRetailerMobile = false
}) {
  return (
    <div className="relative w-[220px]">
      <DatePicker
        selectsRange
        startDate={startDate}
        endDate={endDate}
        onChange={(dates) => {
          const [start, end] = dates;
          onChange(start, end);
        }}
        placeholderText="Select date range"
        className={`px-3 pr-10 py-2 text-sm w-full rounded-xl outline-none
        ${
          isRetailerMobile
            ? "bg-white/10 backdrop-blur-xl border border-white/30 text-black placeholder-black/60"
            : "border border-slate-300"
        }`}
        calendarClassName={
          isRetailerMobile ? "retailer-mobile-datepicker" : ""
        }
        popperClassName={
          isRetailerMobile ? "retailer-mobile-popper" : ""
        }
        isClearable
      />
    </div>
  );
}

// import React from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

// export default function DateRangePicker({ startDate, endDate, onChange }) {
//   return (
//     <DatePicker
//       selectsRange
//       startDate={startDate}
//       endDate={endDate}
//       onChange={(dates) => {
//         const [start, end] = dates;
//         onChange(start, end);
//       }}
      
//       placeholderText="Select date range"
//       className="border border-slate-300 rounded-lg px-3 py-2 text-xs w-[280px]"
//       isClearable
//     />
//   );
// }
